<template>
    <div id="vehiclePermitView">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div class="web-right-sidebar" v-if="loadTabView">
            <div class="right-asset-tab-list">
                <ul class="activetabs" id="tabActive">
                    <li v-bind:class="[ activetab === 0 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab = 0"> Permit Details </a> </li>
                    <li v-bind:class="[ activetab === 1 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab = 1" id="contract_detail"> Contract Details </a> </li>
                    <li v-bind:class="[ activetab === 2 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab = 2" id="billback"> Billback </a> </li>
                    <li v-bind:class="[ activetab === 3 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab = 3" id="amortized"> Amortized </a> </li>
                    <li v-if="canViewGL" v-bind:class="[ activetab === 4 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab = 4" id="generalLedger"> General Ledger </a> </li>
                    <li v-bind:class="[ activetab === 5 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="getActivityLog()"> Activity Log </a> </li>
                </ul>
            </div>
        </div>
        <div id="page-content-wrapper" class="admin-content-area left-asset-detail-section">
            <template v-if="cantAccessPage === true">
                <div class="page-name asset-view-page-name" v-if="permit_number != ''">
                    <div class="page-title"> {{permit_number}} | {{ unit_no }}</div>
                    <div class="btn-groups text-right">
                    <router-link title="Edit Asset Permit" class="btn btn-primary" v-bind:to="{name: 'VehiclePermitEdit',params:{id:permitId}}" v-if="canEditPermit && permit_status != '' && permit_status != 'cancelled'">
                        <i class="fp-edit-icon"> </i> Edit
                    </router-link>
                    <!-- <router-link class="btn btn-secondary" v-bind:to="{name: 'PermitList'}" >
                        <i class="fp-back"> </i> Back
                    </router-link> -->
                    <button type="submit" class="btn btn-secondary" v-on:click.prevent="backButton" >
                        <i class="fp-back"> </i>    Back
                    </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div id="permit-detail" class="admin-page-content vehicle-permit-view list-view" v-if="activetab == 0">
                        <section class="internal-container border-top-table-fl">
                            <div class="list-sections">
                                <div class="form-row no-divider">
                                    <div class="col-md-6">
                                        <div class="row form-group">
                                            <label class="col">Permit Type :</label>
                                            <span class="col">{{permit_type}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Unit No. :</label>
                                            <span class="col">{{unit_no}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Pool :</label>
                                            <span class="col">{{asset_pool}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Facility :</label>
                                            <span class="col">{{facility}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Description :</label>
                                            <span class="col">{{permit_desc}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Create User :</label>
                                            <span class="col">{{created_by}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">IFTA :</label>
                                            <span class="col">{{ifta}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">NM :</label>
                                            <span class="col">{{nm}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">IRP :</label>
                                            <span class="col">{{irp}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">PFR :</label>
                                            <span class="col">{{pyr}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Title Fee :</label>
                                            <span class="col">{{title_fee}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Amount :</label>
                                            <span class="col">{{amount}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Allowance :</label>
                                            <span class="col">{{allowance}}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="row form-group">
                                            <label class="col">Reportable :</label>
                                            <span class="col">{{reportable}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">License Type :</label>
                                            <span class="col">{{type}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Prov / State Code :</label>
                                            <span class="col">{{state_code}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Name :</label>
                                            <span class="col">{{unit_name}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Effective Date :</label>
                                            <span class="col">{{effective_date}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Expiry Date :</label>
                                            <span class="col">{{expiry_date}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Customer :</label>
                                            <span class="col">{{customer}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Cancel Date :</label>
                                            <span class="col">{{cancel_date}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Status :</label>
                                            <span class="col">{{titleCase(permit_status)}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Create Date :</label>
                                            <span class="col">{{created_date}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Billback Amount :</label>
                                            <span class="col">{{bill_back_amount}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Amount Amortized :</label>
                                            <span class="col">{{amount_amortized}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Owner :</label>
                                            <span class="col">{{owner}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div id="contract-detail" class="admin-page-content" v-if="activetab == 1">
                        <section class="internal-container border-top-table-fl">
                            <div class="list-sections customer-view-main" v-if="contractArr.contract_code != undefined && contractArr.contract_code != null">
                                <div class="form-row no-divider">
                                    <div class="col-md-6">
                                        <div class="row form-group">
                                            <label class="col">Contract :</label>
                                            <span class="col">{{contractArr.contract_code}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Unit No. :</label>
                                            <span class="col">{{contractArr.unit_no}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Allowance Remaining Amount :</label>
                                            <span class="col">{{contractArr.allowance_remaining_amount}}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="row form-group">
                                            <label class="col">Customer :</label>
                                            <span class="col">{{contractArr.customer}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Allowance Type :</label>
                                            <span class="col">{{contractArr.allowance_type}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Allowance Amount :</label>
                                            <span class="col">{{contractArr.allowance_total_amount}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                No Data Found
                            </div>
                        </section>
                    </div>

                    <div id="bill-back-detail" class="admin-page-content" v-if="activetab == 2">
                        <section class="internal-container border-top-table-fl">
                            <div class="table-responsive-sm" v-if="billBackArr && billBackArr.length > 0">
                                <table aria-describedby="table" class="table table-bordered table-sm font-1">
                                    <thead>
                                        <tr class="table-primary">
                                            <th class="text-center" scope="col">Permit Type</th>
                                            <th class="text-center" scope="col">Customer</th>
                                            <th class="text-right" scope="col">Amount</th>
                                            <th class="text-right" scope="col">#Invoice</th>
                                            <th class="text-center" scope="col">Effective Date</th>
                                            <th class="text-center" scope="col">Expiry Date</th>
                                            <th class="text-center" scope="col">Description</th>
                                        </tr>
                                    </thead>
                                    <template v-for="(row, index) in billBackArr">
                                        <tr v-bind:key="'amortized'+index">
                                            <td class="text-center">{{row.permit_type}}</td>
                                            <td class="text-center">{{row.customer}}</td>
                                            <td class="text-right">{{row.amount}}</td>
                                            <th class="text-right" scope="col">
                                                <template v-if="row.invoice_id != '-'">
                                                    <a href="javascript:void(0)" title="View Invoice Permit" class="color-blue" v-on:click.prevent="viewInvoicePermit(row.invoice_id)">
                                                        {{row.row.invoice_number}}
                                                    </a>
                                                </template>
                                                <template v-else>
                                                    <span> - </span>
                                                </template>
                                            </th>
                                            <td class="text-center">{{row.from_date}}</td>
                                            <td class="text-center">{{row.to_date}}</td>
                                            <td class="text-center">{{row.mapper_description}}</td>
                                        </tr>
                                    </template>
                                </table>
                            </div>
                            <div v-else>
                                No Data Found
                            </div>
                        </section>
                    </div>
                    <div id="amortized-detail" class="admin-page-content" v-if="activetab == 3">
                        <section class="internal-container border-top-table-fl">
                            <div class="table-responsive-sm" v-if="amortizedArr && amortizedArr.length > 0">
                                <table aria-describedby="table" class="table table-bordered table-sm font-1">
                                    <thead>
                                        <tr class="table-primary">
                                            <th class="text-center">Permit Type</th>
                                            <th class="text-right">Amortized Amount</th>
                                            <th class="text-center">Effective Date</th>
                                            <th class="text-center">Expiry Date</th>
                                            <th class="text-center">Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(row, index) in amortizedArr">
                                            <tr v-bind:key="'amortized'+index">
                                                <td class="text-center">{{row.permit_type}}</td>
                                                <td class="text-right">{{row.amortized_amount}}</td>
                                                <td class="text-center">{{row.from_date}}</td>
                                                <td class="text-center">{{row.to_date}}</td>
                                                <td class="text-center">{{row.mapper_description}}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else>
                                No Data Found
                            </div>
                        </section>
                    </div>
                    <!-- General Ledger -->
                    <div id="general-ledger-detail" class="admin-page-content" v-if="activetab == 4">
                        <section class="internal-container border-top-table-fl">
                            <div v-if="canViewGL && glArr.length > 0">
                                <div class="table-reponsive-sm">
                                    <table aria-describedby="table" id="contact_table" class="table table-bordered table-sm purchase-order-item-table font-1" >
                                        <thead>
                                            <tr class="table-primary">
                                                <th>Account</th>
                                                <th>Reference</th>
                                                <th class="text-right">Debit</th>
                                                <th class="text-right">Credit</th>
                                                <th class="text-right">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="glArr != undefined && glArr.length > 0">
                                            <template v-for="(glItem , glKey) in glArr">
                                                <tr :key="'gl'+glKey">
                                                    <template v-if="glItem.account_description == 'Total'">
                                                        <td class="text-right">&nbsp;</td>
                                                        <td class="text-right">{{glItem.account_description}}</td>
                                                    </template>
                                                    <template v-else>
                                                        <td>{{glItem.account_description}}</td>
                                                        <td>{{glItem.description}}</td>
                                                    </template>
                                                    <td class="text-right">{{glItem.debit}}</td>
                                                    <td class="text-right">{{glItem.credit}}</td>
                                                    <td class="text-right">{{glItem.journal_amount}}</td>
                                                </tr>
                                            </template>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td colspan="4"><h5>No GL Found</h5></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-else>
                                No Data Found.
                            </div>
                        </section>
                    </div>
                    <!--PermitActivityLog-->
                    <div id="permit-activity-log" class="list-view" v-show="activetab == 5">
                        <div class="bg-white data-table p-0">
                            <permit-activity-log-list :activityLogVal="activityLogsTabValue"></permit-activity-log-list>
                        </div>
                    </div>

                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer><!--tab content--><!--tab content-->
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import {contractMixins} from '../mixins/contractMixins';
export default {
    name: "vehiclePermitView",
    components: {
        PermitActivityLogList: () => import('@/components/ActivityLogList.vue'),
    },
    mixins:[commonMixins,contractMixins],
    data: () => ({
        ifta:0,
        nm:0,
        irp:0,
        pyr:0,
        title_fee:0,
        admin_fee:0,
        permissions: [],
        cantAccessPage: "",
        loading:false,
        permitId:0,
        loadTabView:false,
        activetab:0,
        canEditPermit:false,
        permit_number:"",
        permit_type:"",
        state_code:"",
        unit_no:"",
        unit_name:"",
        asset_pool:"",
        customer:"",
        facility:"",
        effective_date:"",
        expiry_date:"",
        cancel_date:"",
        permit_desc:"",
        created_by:"",
        created_date:"",
        permit_status:"",
        amount:0,
        bill_back_amount:0,
        allowance:0,
        amount_amortized:0,
        reportable:"",
        owner:"",
        type:"",
        amortizedArr:[],
        billBackArr:[],
        contractArr:[],
        canViewGL:false,
        glArr:[],
        activityLogsTabValue:"dontLoadList",
        tabMenuArray:[],
    }),
    watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'view_asset_permit') {
                        self.cantAccessPage = true;
                        self.loadTabView = true;
                    }

                    if (permissions[i].name == 'add_asset_permit') {
                        self.canEditPermit = true;
                    }
                    if (permissions[i].name == 'view_general_ledger') {
                        self.canViewGL = true;
                    }
                }
            }

        }
    },
    created: function() {

    },
    mounted: function() {
        var self = this;
        self.getPermissions();
        self.permitId = self.$route.params.id;
        self.loadPermitData();
    },
    metaInfo() {
        return {
            title: (this.permit_number != "") ? this.permit_number + " | Asset Permit View | " +process.env.COPYRIGHT_NAME:"Asset Permit View | " +process.env.COPYRIGHT_NAME
        }
    },
    methods: {

        loadPermitData() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/permit/view",
                type: "GET",
                headers: this.ajxHeaders,
                data:{
                    id:self.permitId
                },
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    if (data.status == "success") {
                        self.permit_number = data.content.permit_number;
                        self.permit_type = data.content.permit_type + " | " + data.content.permitTypeDes;
                        self.state_code = data.content.stateCode + " | " +data.content.stateName;
                        self.unit_no = data.content.unit_no;
                        self.unit_name = data.content.vName;
                        self.asset_pool = data.content.poolCode + " | " + data.content.poolDesc;
                        if (data.content.customer_id != null) {
                            self.customer = data.content.custCode + " | " + data.content.custName;
                        }else{
                            self.customer = "-";
                        }
                        self.facility = data.content.locCode + " | " + data.content.locName;
                        self.effective_date = data.content.effective_date;
                        self.expiry_date = data.content.expiry_date;
                        if (data.content.cancel_date != null) {
                            self.cancel_date = data.content.cancel_date;
                        }else{
                            self.cancel_date = "-";
                        }
                        self.ifta = data.content.ifta;
                        self.nm = data.content.nm;
                        self.irp = data.content.irp;
                        self.pyr = data.content.pyr;
                        self.title_fee = data.content.title_fee;
                        self.admin_fee= data.content.admin_fee;
                        self.amount = data.content.permit_amount;
                        self.permit_status = data.content.status;
                        self.permit_desc = data.content.description;
                        self.created_by = data.content.create_user;
                        self.created_date = data.content.create_date;
                        if (data.content.reportable != null && data.content.reportable != "") {
                            self.reportable = self.titleCase(data.content.reportable);
                        }else{
                            self.reportable = "-";
                        }
                        self.owner = data.content.owner;
                        self.type = data.content.license_type;
                        self.bill_back_amount = data.content.bill_back_amount;
                        self.amount_amortized = data.content.amortized_amount;
                        self.allowance = data.content.allowance_amount;
                        self.billBackArr = data.content.billback_details;
                        self.amortizedArr = data.content.amortized_details;
                        self.contractArr = data.content.contract_details;
                        if (data.content.gl != undefined && data.content.gl != null) {
                            self.glArr = data.content.gl;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'asset-permit-view')
                }
            });
        },
        backButton(){
          var self = this;
             var url = '/vehiclepermit/list';
             if(self.$route.query.from != undefined && self.$route.query.from == "gl" ){
                self.$router.push('/report/general-ledger');
                return;
             }else{
               self.redirectPageUrl(url);
             }
        },
        getActivityLog(){
          var self = this;
          self.activetab = 5;
          var path = window.location.pathname;
          var segments = path.split("/");
          if(!self.tabMenuArray.includes(self.activetab)){

            this.$root.$emit('activity_log_opted','asset permit',segments[3]);
            self.activityLogsTabValue = "loadList";   // flag value set to loadList so that filters in list work properly.
          }
        },
        viewInvoicePermit(invoice_id) {
            let self = this;
            let link = '/invoice/permit/'+invoice_id;
            let routeData = self.$router.resolve(link);
            window.open(routeData.href, '_blank');
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/VehiclePermitView.vue